import {Schema, String, pattern} from 'effect/Schema';

export const DoubleString = String.pipe(
    // eslint-disable-next-line security/detect-unsafe-regex
    pattern(/^-?\d+(\.\d+)?$/)
) as unknown as Schema<DoubleString>;
export type DoubleString = import('../src/DoubleString').DoubleString;
